import Vue from "vue";
import VueRouter from "vue-router";
import Config from "@/views/Config.vue";
import TimeTable from "@/views/TimeTable.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/home",
    name: "home",
    component: TimeTable
  },
  {
    path: "/config",
    name: "config",
    component: Config
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
